import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';

import AlertDialog from '../components/common/AlertDialog';

export default class CreatorsBloc {
  dispose$ = new Subject();
  isSubmitting$ = new BehaviorSubject(false);

  constructor({ authRepository, drawerRepository, creatorRepository, dialogRepository }) {
    this.drawerRepository = drawerRepository;
    this.creatorRepository = creatorRepository;
    this.dialogRepository = dialogRepository;

    this.creatorRepository.searchCriteria$
      .pipe(
        filter(() => !!authRepository.auth$.getValue()),
        tap((criteria) => this.getCreators(criteria)),
        takeUntil(this.dispose$)
      )
      .subscribe();
  }

  dispose() {
    this.creatorRepository.searchCriteria$.next(null);
    this.dispose$.next(true);
  }

  openResendInvite(creator, component) {
    this.creatorRepository.creatorToInvite$.next(creator);
    this.drawerRepository.loadDrawer(component);
  }

  async inviteCreator(name, telephone, email, isTrainee) {
    this.isSubmitting$.next(true);

    try {
      await this.creatorRepository.inviteCreator(name, telephone, email, isTrainee);
      this.dialogRepository.loadDialog(AlertDialog, {
        btnAction: () => this.dialogRepository.toggleDialog(false),
        btnText: 'Dismiss',
        message: `And invitation has been sent to ${email}. The user will be activated once they have created their password.`,
        title: 'Invitation Sent',
      });

      await this.getCreators(this.creatorRepository.searchCriteria$.getValue());
    } finally {
      this.isSubmitting$.next(false);
    }
  }

  async getCreators(criteria) {
    await this.creatorRepository.getCreators(criteria);
  }

  updateSearchCriteria(criteria) {
    this.creatorRepository.searchCriteria$.next(criteria);
  }

  get creators$() {
    return this.creatorRepository.creators$;
  }
}
